export default __webpack_public_path__ + "static/Comp6441Image-37afa8e898b69a229c6d21f14de59b19.png";